import { createTypes } from 'reduxsauce'
 
export default createTypes(`
    GET_SIGN_CONTRACT_INITIAL_DATA
    PREPARE_CONTRACT
    ON_SIGNING_EVENT
    HANDLE_SIGN_CONTRACT_ERROR
`, {}) // options - the 2nd parameter is optional